import { css } from 'styled-components';
import { getOverrideBackground } from '../../../utils/utilityFunction';
import breakPoints from '../../../themes/breakpoints';
var background;
var styles = css(["", ";width:100%;&.content-spacer{&-large{height:60px;@media (min-width:", "){height:110px;}}&-medium{height:40px;@media (min-width:", "){height:80px;}}&-small{height:25px;@media (min-width:", "){height:50px;}}&-line{height:2px;}&-none{height:0;}}"], function (props) {
  if (props.background) {
    var _props$theme, _props$theme2;
    var overrideBackground = props.background;
    background = getOverrideBackground({
      entry: overrideBackground,
      themeBgColor: (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.accordion.bodyBackgroundColor,
      colorPalette: (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.palette
    });
    return background.css;
  }
}, breakPoints.desktop, breakPoints.desktop, breakPoints.desktop);
export default styles;